import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { ErrorBoundary, Text } from "@jsq/ds/core";
import { richMarkdownComponents } from "./components";
import * as styles from "./styles_vanilla.css";

export type MarkdownContentProps = {
  content: string;
  /**
   * Renders headings, lists, blockquotes, code, and links through `@jsq/ds`
   * `Text` (and a link URL allowlist) instead of default HTML elements, and
   * degrades to a plain-text fallback if rendering throws. Off by default
   * so existing callers keep their current output unchanged.
   */
  richFormatting?: boolean;
};

export const MarkdownContent = ({ content, richFormatting = false }: MarkdownContentProps) => {
  if (!content) return null;

  if (!richFormatting) {
    return (
      <div className={styles.markdownContent}>
        <ReactMarkdown remarkPlugins={[remarkGfm]}>{content}</ReactMarkdown>
      </div>
    );
  }

  return (
    <ErrorBoundary fallback={<Text variant="regular-md">{content}</Text>}>
      <div className={styles.richMarkdownContent}>
        <ReactMarkdown components={richMarkdownComponents} remarkPlugins={[remarkGfm]}>
          {content}
        </ReactMarkdown>
      </div>
    </ErrorBoundary>
  );
};
